import { AxiosError } from 'axios';
import { useState } from 'react';

import { CurrentConfigDataInterface } from '../../../models/dashboard/dashboard/currentConfigData';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../models/https';
import useHttps from '../../useHttps';

const useChartFilter = () => {
  const request = useHttps();
  // const dispatch = useAppDisPatch();
  const [loading, setLoading] = useState(false);
  const [chartData, getChartData] = useState<any>();

  const onChartFilterError = (err: AxiosError<ErrorHttpResponse>) => {
    // console.error(err?.response?.data?.message ?? 'Something went wrong while retrieving dashboard data');
  };

  const onChartFilterSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<CurrentConfigDataInterface>) => {
    // dispatch(lifeTimeOnboardingDataActions.setLifeTimeOnboardingData(data));
    getChartData(data);
  };

  const chartFilter = async (path: string) => {
    const url: HttpConfig = {
      url: path,
      // url: `ba/v1/company/onboarding-timeline`,
      method: 'get',
    };

    return request(url, onChartFilterSuccess, setLoading, onChartFilterError);
  };

  return { chartFilter, loading, chartData };
};

export default useChartFilter;
